import { useEffect } from 'react';

/**
 * Custom hook for resetting form fields using React Hook Form.
 *
 * @param {string} field - The name of the field that triggers the reset when it changes.
 * @param {boolean} [condition=false] - A condition that determines whether the fields should be reset.
 * @param {Array} [fieldsToReset=[]] - An array of field names to be reset.
 * @param {Function} resetFunc - A function from `useForm` to reset a specific form field.
 * @returns {void} This hook does not return anything.
 */

const useResetRhfFields = (field, condition = false, fieldsToReset = [], resetFunc) => {
    useEffect(() => {
        if (condition) {
            if (fieldsToReset.length > 0 && resetFunc) {
                fieldsToReset.map((f) => {
                    resetFunc(f);
                });
            }
        }
    }, [field]);
};

export default useResetRhfFields;
